export const getAllQualifications = async (payload, authToken) => {
  // Visibility-> active,disabled,"all"
  const { pageNo, limit, isSorted, sortBy, searchText, visibility, tagType } =
    payload;
  const url = `${
    process.env.REACT_APP_BASE_URL
  }/getAllQualifications?pageNo=${pageNo}&limit=${limit}&visibility=${visibility}&tagType=${tagType}${
    searchText ? "&searchText=" + searchText : ""
  }${sortBy ? "&sortBy=" + sortBy : ""}${
    isSorted ? "&isSorted=" + isSorted : ""
  }`;

  try {
    return await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: authToken,
      },
    })
      .then((res) => res.json())
      .catch((error) => error.message);
  } catch (error) {
    console.error(
      "Coming from Tag services : getAllEligibility() ",
      error.message
    );
    if (error.message === "Network Error") {
      return error.message;
    }
  }
};

export const updateQualification = async (payload, authToken) => {
  try {
    return await fetch(
      `${process.env.REACT_APP_BASE_URL}/updateQualification`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
        },
        body: JSON.stringify(payload),
      }
    )
      .then((res) => res.json())
      .catch((error) => error.message);
  } catch (error) {
    console.error(
      "Coming from Tag services : updateEligibility()",
      error.message
    );
    if (error.message === "Network Error") {
      return error.message;
    }
  }
};

export const updateQualifcationVisibility = async (payload, authToken) => {
  try {
    return await fetch(
      `${process.env.REACT_APP_BASE_URL}/updateQualifcationVisibility`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
        },
        body: JSON.stringify(payload),
      }
    )
      .then((res) => res.json())
      .catch((error) => error.message);
  } catch (error) {
    console.error(
      "Coming from Tags services : updateEligibilityVisibility()",
      error.message
    );
    if (error.message === "Network Error") {
      return error.message;
    }
  }
};
